import AbstractCalls from "./AbstractCalls";

class RaceConfigCalls extends AbstractCalls {
  create(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/create");
    return AbstractCalls.post(cmdUri, body, options);
  }

  update(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/update");
    return AbstractCalls.put(cmdUri, body, options);
  }

  delete(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/delete");
    return AbstractCalls.delete(cmdUri, body, options);
  }

  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  finishRegistration(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishRegistration");
    return AbstractCalls.post(cmdUri, body, options);
  }

  finishPreregistrationFees(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishPreregistrationFees");
    return AbstractCalls.post(cmdUri, body, options);
  }

  finishMastersPaymentDeadline(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishMastersPaymentDeadline");
    return AbstractCalls.post(cmdUri, body, options);
  }

  finishLotteryOnePaymentDeadline(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishLotteryOnePaymentDeadline");
    return AbstractCalls.post(cmdUri, body, options);
  }

  finishLotteryTwoPaymentDeadline(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishLotteryTwoPaymentDeadline");
    return AbstractCalls.post(cmdUri, body, options);
  }

  finishVoucherPaymentDeadline(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/finishVoucherPaymentDeadline");
    return AbstractCalls.post(cmdUri, body, options);
  }

  drawLotteryOne(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/drawLotteryOne");
    return AbstractCalls.post(cmdUri, body, options);
  }

  drawLotteryTwo(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/drawLotteryTwo");
    return AbstractCalls.post(cmdUri, body, options);
  }

  processLotteryOne(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/processLotteryOne");
    return AbstractCalls.post(cmdUri, body, options);
  }

  processLotteryTwo(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/processLotteryTwo");
    return AbstractCalls.post(cmdUri, body, options);
  }

  bulkAssignStartNumbers(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/bulkAssignStartNumbers");
    return AbstractCalls.post(cmdUri, body, options);
  }

  setMerchandises(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/setMerchandises");
    return AbstractCalls.put(cmdUri, body, options);
  }

  /**
   * Replace the race segment list.
   * @param {{ _id: string, segments: Array }} body
   * @param {Object} [options]
   */
  setSegments(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/setSegments");
    return AbstractCalls.put(cmdUri, body, options);
  }

  setVariantGroup(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "race/setVariantGroup");
    return AbstractCalls.put(cmdUri, body, options);
  }
}

export default new RaceConfigCalls();
